import { useState } from 'react';
import { Typography } from '@mui/material';
import { updateMeta } from '../../../redux/meta';
import { useAppDispatch } from '../../../pages/assessment';
import { AssessmentButtons, AssessmentCrisisAlert } from '../shared';

const ZocdocIntroductionFirst = () => {
  const dispatch = useAppDispatch();

  const [isContinuing, setIsContinuing] = useState(false);
  const onClick = () => {
    setIsContinuing(true);
    dispatch(updateMeta());
  };

  return (
    <>
      <Typography>
        So we can provide the best possible care, we'll need a little more
        information, including your medical history.
      </Typography>
      <br />
      <Typography>
        You may have already entered some of this information on Zocdoc, but we
        do need to confirm it to make sure your profile is accurate.
      </Typography>
      <br />
      <Typography>This will take about 5-10 minutes.</Typography>
      <AssessmentCrisisAlert />
      <AssessmentButtons
        primary={{
          children: 'Get started',
          disabled: isContinuing,
          loading: isContinuing,
          onClick,
        }}
      />
    </>
  );
};

export default ZocdocIntroductionFirst;
